import { ButtonEmpty, FlexGroup, FlexItem, Text } from '@antoree/ant-ui';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './Notification.module.scss';

type Props = {
  handleClickUnread: () => void;
  handleClickAll: () => void;
  isUnread: boolean;
};

const NotificationHeader = ({
  handleClickUnread,
  handleClickAll,
  isUnread,
}: Props) => {
  return (
    <>
      <FlexGroup alignItems="center">
        <FlexItem grow={false}>
          <Text className="font-bold text-xl">
            <FormattedMessage
              id="notification.header.title"
              defaultMessage="Notification"
            />
          </Text>
        </FlexItem>
      </FlexGroup>
      <FlexGroup>
        <FlexItem grow={false}>
          <ButtonEmpty
            className={`${styles.notificationHeaderButton} ${
              !isUnread ? styles.notificationHeaderButtonActive : ''
            }`}
            onClick={handleClickAll}
          >
            <FormattedMessage
              id="notification.header.all"
              defaultMessage="All"
            />
          </ButtonEmpty>
        </FlexItem>
        <FlexItem grow={false}>
          <ButtonEmpty
            className={`${styles.notificationHeaderButton} ${
              isUnread ? styles.notificationHeaderButtonActive : ''
            }`}
            onClick={handleClickUnread}
          >
            <FormattedMessage
              id="notification.header.unread"
              defaultMessage="Unread"
            />
          </ButtonEmpty>
        </FlexItem>
      </FlexGroup>
    </>
  );
};

export default memo(NotificationHeader);
